import { formState, type ValidationError } from '../../../../state/form.state';
import { registrationState } from '../registration-state';

type SectionValidationError = Pick<ValidationError, 'field'>;

export interface SectionCardState {
  errorCount: number;
  complete: boolean;
}

const matchesSectionPath = (field: string, sectionPath: string): boolean =>
  field === sectionPath || field.startsWith(`${sectionPath}.`);

export function getSectionCardState(
  sectionPaths: readonly string[],
  errors?: readonly SectionValidationError[]
): SectionCardState {
  const validationErrors = errors ?? formState.get().validationErrors;
  const touchedFields = Array.from(registrationState.touchedFields.get());

  const errorCount = validationErrors.filter((error) =>
    sectionPaths.some((sectionPath) => matchesSectionPath(error.field, sectionPath))
  ).length;

  const touched = touchedFields.some((field) =>
    sectionPaths.some((sectionPath) => matchesSectionPath(field, sectionPath))
  );

  return {
    errorCount,
    complete: touched && errorCount === 0,
  };
}